import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import { PREFIX_SPROMOTION_API } from '@/service'
const api = {
  secKillList: PREFIX_SPROMOTION_API + 'promotion/getSeckillList.do',
  newSecKillList: PREFIX_SPROMOTION_API + 'promotion/getPromotionList.do' // 抢购
}
export default {
  async getSeckillList({ commit }, { cityCode }) {
    try {
      const query = queryString.stringify({
        cityCode,
        serviceId: 40
      })
      const res = await fetch(`${api.secKillList}?${query}`)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
      return ''
    }
  },
  async getNewSeckillList(
    { commit },
    { cityCode, pageIndex, pageSize, serviceId }
  ) {
    // 抢购
    try {
      const query = queryString.stringify({
        cityCode,
        serviceId,
        promType: 1, // 1 抢购
        pageIndex,
        pageSize
      })
      const res = await fetch(`${api.newSecKillList}?${query}`)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
      return ''
    }
  }
}
